var AppStorageUtil
var browserWindow
var isLocalStorageAvailable
var temporaryStorage
var temporarySessionStorage